import { BoxProps } from '@mui/material';
import { Column, Row } from '../../styles';
import { Testimonial } from '../../types/Testimonial';
import { ProfilePicture } from '../profile-picture/ProfilePicture';
import {
    Quote,
    TestimonialCardContainer,
    TestimonialCardContent,
    TestimonialCardText
} from './styles';

interface Props extends BoxProps {
    testimonial: Testimonial;
    index: number;
    noClamp?: boolean;
}

const gooseFeeties = ['"', "'", '`', '´', '„'];

const TestimonialCard = ({ testimonial, index, noClamp, ...boxProps }: Props) => {
    let quote = testimonial.quote;

    // prevent double """
    const firstLetter = testimonial.quote.charAt(0);
    if (gooseFeeties.includes(firstLetter)) quote = quote.slice(1);

    const lastLetter = testimonial.quote.charAt(testimonial.quote.length - 1);
    if (gooseFeeties.includes(lastLetter)) quote = quote.slice(0, testimonial.quote.length - 2);

    return (
        <TestimonialCardContainer index={index} py={4} px={3} {...boxProps}>
            <TestimonialCardContent>
                <Quote noClamp={noClamp}>„{quote}&quot;</Quote>
                <Row gap={2}>
                    <ProfilePicture
                        imageUrl={testimonial.picture?.url}
                        altText={`Picture of ${testimonial.firstname} ${testimonial.lastname}`}
                    />
                    <Column>
                        <TestimonialCardText>
                            {testimonial.firstname} {testimonial.lastname}
                        </TestimonialCardText>
                        <TestimonialCardText>{testimonial.position}</TestimonialCardText>
                    </Column>
                </Row>
            </TestimonialCardContent>
        </TestimonialCardContainer>
    );
};

export { TestimonialCard };
